/**
 * Maps API lifecycle fields → notebook store (single source for hydrate + sync).
 * @param {Record<string, unknown> | null | undefined} apiNotebook
 */
export function lifecycleFieldsFromApi(apiNotebook) {
  if (!apiNotebook) {
    return {
      locked: false,
      planReadOnly: false,
      lifecycleView: "active",
      isDeleted: false,
      restoreRequiresFolder: false,
      parentFolderId: null,
      parentFolderName: null,
      workspaceId: null,
      isArchived: false,
    };
  }

  const readOnly = Boolean(
    apiNotebook.read_only ?? apiNotebook.is_locked ?? false,
  );
  const lifecycleView =
    apiNotebook.lifecycle_view ??
    (apiNotebook.is_deleted
      ? "deleted"
      : readOnly && apiNotebook.is_archived
        ? "archived"
        : "active");

  return {
    locked: readOnly,
    planReadOnly: Boolean(apiNotebook.plan_read_only),
    lifecycleView,
    isDeleted: Boolean(apiNotebook.is_deleted),
    restoreRequiresFolder: Boolean(apiNotebook.restore_requires_folder),
    parentFolderId: apiNotebook.parent_folder_id ?? null,
    parentFolderName: apiNotebook.parent_folder_name ?? null,
    workspaceId: apiNotebook.workspace_id ?? null,
    isArchived:
      lifecycleView === "archived" ||
      Boolean(apiNotebook.is_archived && !apiNotebook.is_deleted),
  };
}
